<template>
  <div>
    <RejectReason
      v-if="product.rejectReasons.length"
      :product="product"
    />
    <RejectReasonDetail
      v-else-if="product.rejectReasonDetails.length"
      :product="product"
    />
    <div v-else>
      --
    </div>
  </div>
</template>
<script>
import Index from './Index';

export default {
  name: 'IndexRejected',
  extends: Index,
};
</script>
